import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import Select from "react-select";

import "css/common/modal.scss";

export function ModalLanguageUI({
  onSubmit,
  onCancel,
  isOpen,
  selectedTranslation,
  t,
}) {
  const [selectedOption, setSelectedOption] = useState(t("placeholder"));
  const languagesBySlugAndId = useSelector(
    (state) => state.languages.bySlugAndId,
  );

  useEffect(() => {
    setSelectedOption(t("placeholder"));
  }, [isOpen]);

  const handleChange = (selected) => {
    if (selected) {
      setSelectedOption(selected);
    } else {
      setSelectedOption();
    }
  };

  const langs = t("languages:langs", { returnObjects: true });

  const languageOptions = useMemo(() => {
    const selectedLanguage = selectedTranslation.map(
      (translation) =>
        languagesBySlugAndId[translation.language || translation.language_uuid],
    );

    return (
      Object.keys(langs)
        .filter((key) =>
          selectedLanguage.find((selected) => selected?.language !== key),
        )
        .map((key) => ({
          value: key,
          label: langs[key],
        }))
        // sort with localCompare
        .sort((a, b) => a.label.localeCompare(b.label))
    );
  }, [languagesBySlugAndId, langs, selectedTranslation, t]);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return isOpen ? (
    <div className="modal-container" onClick={() => onCancel()}>
      <div className="modal-box" onClick={(e) => handleClick(e)}>
        <div className="modal-title">{t("title")}</div>
        <div className="modal-body">
          <Select
            name="form-field-name"
            value={selectedOption}
            onChange={handleChange}
            options={languageOptions}
            placeholder={t("placeholder")}
            className="editor-select"
            classNamePrefix="slct"
          />
        </div>
        <div className="modal-btn">
          <button className="btn" onClick={() => onCancel()}>
            {t("cancel")}
          </button>
          <button className="btn" onClick={() => onSubmit(selectedOption)}>
            {t("submit")}
          </button>
        </div>
      </div>
    </div>
  ) : null;
}

ModalLanguageUI.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  selectedTranslation: PropTypes.arrayOf(PropTypes.object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation(["modal", "languages"])(ModalLanguageUI);
